import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Header from '../../components/Header';

import {
  nextAction,
} from '../../actions/navigation';

import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import Container from '../../components/Container';

// Configuration & Assets
import { parseUrlParams } from '../../utils/parseUrlParams';
import iconACH from '../../assets/images/icon-ach.svg';
import iconCheck from '../../assets/images/icon-checkpayment.svg';

import './style.scss';

const LoanDetails = (props) => {
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);

  const handleButtonClick = (flag) => {
    const match = useParams();
    const { dispatch } = props;
    const params = parseUrlParams(window.location.search);
    const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
    setIsProgressVisible(true);
    dispatch(nextAction({
      entityType: 'application',
      entityId: params.appid,
      workflowType,
      data: {
        manualMethod: flag,
      },
      onUploadProgress: (progressEvent) => {
        setIsProgressVisible(true);
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  return (
    <Transition className="transition-item wrapper manual-payment">
      <Header />
      <ContentWrapper className="ach-container">
        <Container className="container">
          <FormRow>
            <FormColumn className="col offset-1 alignCenter ach-page" offset={10}>
              <h1>ACH Auto-Pay Election</h1>
              <p>Enroll in optional ACH Auto-Pay for FREE and never miss a payment again.</p>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <button type="button" onClick={() => { handleButtonClick('ach'); }} className="btn btn-outline">
                <FormRow>
                  <div className="col-auto">
                    <img src={iconACH} alt="" style={{ marginTop: '4px' }} />
                  </div>
                  <div className="col-auto">
                    <h5>Manually Enter ACH Info</h5>
                    <small>•&nbsp; Autopay &nbsp;•&nbsp; Free</small>
                  </div>
                </FormRow>
              </button>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <button type="button" onClick={() => { handleButtonClick('check'); }} className="btn btn-outline">
                <FormRow>
                  <div className="col-auto">
                    <img src={iconCheck} alt="" />
                  </div>
                  <div className="col-auto">
                    <h5>Pay By Check</h5>
                    <small>Manual</small>
                  </div>
                </FormRow>
              </button>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn className="eRegText">
              <p>Please Note: Enrolling in ACH Auto-Pay is optional. The Bank&apos;s credit decision is not dependent on whether you enroll in ACH Auto-Pay. You can change your method of payment at any time in the future.</p>
            </FormColumn>
          </FormRow>
        </Container>
      </ContentWrapper>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

LoanDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(LoanDetails);
